import React from 'react';
import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { initializeApp } from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';

if (!process.env.REACT_APP_FIREBASE_CONFIG) {
  throw new Error('REACT_APP_FIREBASE_CONFIG env var is required. Check the .env file');
}

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID,
};

const CLOUD_STORE_NAME = 'operations-platform-app';

const Parse = require('parse');
Parse.initialize(process.env.REACT_APP_PARSE_APP_ID, process.env.REACT_APP_PARSE_JS_KEY);
Parse.serverURL = 'https://parseapi.back4app.com/';

initializeApp(JSON.parse(atob(process.env.REACT_APP_FIREBASE_CONFIG)));
initializeApp(config, CLOUD_STORE_NAME);
// Sentry.init(JSON.parse(atob(process.env.REACT_APP_SENTRY)));

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
